/**
 * 台灣身分證／居留證統一證號驗證
 * 對齊 api/app/Rules/TaiwanIdNumber.php（本國 1/2、新式 8/9、舊式 A–D + 檢查碼）
 */

const LETTER_MAP = {
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    G: 16,
    H: 17,
    I: 34,
    J: 18,
    K: 19,
    L: 20,
    M: 21,
    N: 22,
    O: 35,
    P: 23,
    Q: 24,
    R: 25,
    S: 26,
    T: 27,
    U: 28,
    V: 29,
    W: 32,
    X: 30,
    Y: 31,
    Z: 33
};

export const TAIWAN_ID_LABEL = '身分證／居留證統一證號';

export function normalizeTaiwanIdNumber(value) {
    const normalized = String(value ?? '')
        .trim()
        .toUpperCase();
    return normalized || '';
}

/**
 * @param {string} id
 * @returns {boolean}
 */
export function isValidTaiwanIdNumber(id) {
    const value = normalizeTaiwanIdNumber(id);
    if (!/^[A-Z][1289A-D][0-9]{8}$/.test(value)) {
        return false;
    }

    const letter = value[0];
    const secondChar = value[1];
    const restNumbers = value.slice(2);

    if (!(letter in LETTER_MAP)) {
        return false;
    }

    const letterNum = LETTER_MAP[letter];
    let sum = Math.floor(letterNum / 10) + (letterNum % 10) * 9;

    let n2;
    if (/[0-9]/.test(secondChar)) {
        n2 = Number(secondChar);
    } else {
        if (!(secondChar in LETTER_MAP)) {
            return false;
        }
        n2 = LETTER_MAP[secondChar] % 10;
    }
    sum += n2 * 8;

    for (let i = 0; i < 7; i += 1) {
        sum += Number(restNumbers[i]) * (7 - i);
    }

    const checksum = (10 - (sum % 10)) % 10;
    const lastDigit = Number(value[9]);
    return checksum === lastDigit;
}

/**
 * @param {string} value
 * @param {{ required?: boolean }} [opts]
 * @returns {string} 錯誤訊息；空字串表示通過
 */
export function taiwanIdNumberError(value, opts = {}) {
    const normalized = normalizeTaiwanIdNumber(value);
    if (!normalized) {
        return opts.required ? `請輸入${TAIWAN_ID_LABEL}` : '';
    }
    if (!isValidTaiwanIdNumber(normalized)) {
        return `${TAIWAN_ID_LABEL}格式不正確（本國身分證或居留證統一證號）`;
    }
    return '';
}
